import script from "./VideoMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoMessage.vue?vue&type=script&setup=true&lang=js"

import "./VideoMessage.vue?vue&type=style&index=0&id=6af684b7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af684b7"]])

export default __exports__